import moment from 'moment-timezone';
import React from 'react';
import { View } from 'react-native';

import { useConsumerUsageSummaryQuery } from 'apollo/queries/autogenerate/hooks';
import { ConsumerUsageSummary } from 'apollo/queries/autogenerate/schemas';
import ListItem from 'shared/modules/usage/components/molecules/ListItem';
import Separator from 'shared/modules/usage/components/molecules/ListItemDivider';
import ListSection from 'shared/modules/usage/components/molecules/ListSection';
import { formatYearMonthDate } from 'shared/utils/japanese';

export default function RecentSettlements({
  onItemPress,
}: {
  onItemPress: (
    settlement: ConsumerUsageSummary['recentSettlements'][0]
  ) => void;
}) {
  const { data, error } = useConsumerUsageSummaryQuery();

  const settlements = data?.consumerUsageSummary.recentSettlements || [];

  return (
    <ListSection
      title="お支払い履歴"
      errorMessage={error ? 'ネットワークエラー' : ''}
      emptyMessage={
        settlements?.length ? '' : '最近のお支払い履歴がありません。'
      }
    >
      {settlements.map((settlement, index: number) => {
        let title = '';

        if (settlement.isPayNowSettlement) {
          title = 'すぐ払い'; // pay now
        } else if (settlement.isVanTransferSettlement) {
          title = '銀行振込'; // bank transfer
        } else if (settlement.paidBillingCycle) {
          const month =
            moment(settlement.paidBillingCycle).tz('Asia/Tokyo').month() + 1;

          title = `${month}月分の支払い`; // settlement for month
        }

        return (
          <View key={settlement.id}>
            <ListItem
              title={title}
              date={formatYearMonthDate(settlement.pushedAt, 'en')}
              iconName="settlement"
              amount={settlement.amount}
              onPress={() => onItemPress(settlement)}
              id={`recent-settlements-item-${index}`}
            />
            {index !== settlements.length - 1 && <Separator />}
          </View>
        );
      })}
    </ListSection>
  );
}
